import React, { Component, Children } from "react";

// Styles
import "./styles.scss";

import cx from "classnames";
import { history } from "./../../utils/history";
import { currency } from "./../../utils/currencyFormat";
import { connect } from "react-redux";
import moment from "moment";
import { fetchHomeFeed } from "../../redux/actions";
import DefaultModal from "../../components/Modal/defaultModal";
const Card = ({ children, className }) => {
  return <div className={cx("card", className)}>{children}</div>;
};

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSettingsVisible: false,
    };
  }

  componentWillMount() {
    this.props.fetchHomeFeed();
    document.addEventListener("deviceready", this.onDeviceReady(), false);
  }

  onDeviceReady() {
    window.firebase.analytics().logEvent("landing-home");
  }

  returnTime(time) {
    let hour = time.split(":")[0];
    let min = time.split(":")[1];
    let finalHour =
      hour > 12 ? (hour - 12 > 10 ? hour - 12 : 0 + hour - 12) : hour;
    let postFix = hour > 12 ? "pm" : "am";
    return finalHour + ":" + min + postFix;
  }

  handleWalletCardClick(walletId) {
    history.push("/txn-details?searchID=" + walletId);
  }

  render() {
    const { state, props } = this;
    let homeData = props.homeData.data;
    return (
      <div className="screen home">
        {homeData && (
          <>
            <div className="profile d-flex align-center justify-between animated fadeInDown">
              <div className=" d-flex align-center justify-start">
                <div className="user-img">
                  <img src={require("../../assets/user.svg")} />
                </div>
                <div className="details">
                  <p>
                    hi <span>{homeData.profile.customer_name}!</span>
                  </p>
                  <p>+91 {homeData.profile.customer_mobile}</p>
                </div>
              </div>
              {/* <img
                onClick={() => {
                  localStorage.clear();
                  history.push("/login");
                }}
                className="logout"
                src={require("./../../assets/logout.svg")}
              /> */}
              <img
                onClick={() =>
                  this.setState({
                    isSettingsVisible: true,
                  })
                }
                src={require("../../assets/settings.svg")}
                className="logout"
              />
            </div>
            <div className="neighbour-card animated fadeInUp">
              <img className="logo" src={require("../../assets/logo.png")} />
              <div className="details">
                <p>{homeData.profile.customer_name}</p>
                <p>
                  <span>balance</span> ₹
                  {currency.format(homeData.card_balance.current_total_balance)}
                </p>
              </div>
            </div>
            <Card className="card-details animated fadeInUp delay-0-5s">
              <div className="d-flex justify-between">
                <div>
                  <p className="loaded">loaded to card</p>
                  <p className="cashback">
                    (earned{" "}
                    <span>
                      ₹
                      {currency.format(
                        homeData.card_balance.total_loaded_discount
                      )}
                    </span>{" "}
                    cashback)
                  </p>
                </div>
                <p className="value">
                  + ₹{currency.format(homeData.card_balance.total_loaded_total)}
                </p>
              </div>
              <div className="d-flex justify-between">
                <p className="redeem">redeemed till now</p>
                <p className="value">
                  - ₹
                  {currency.format(homeData.card_balance.total_redeemed_total)}
                </p>
              </div>
            </Card>
            <div className="wallets d-flex justify-between animated fadeInUp delay-1s">
              {homeData.wallets.map((item, index) => {
                return (
                  <div
                    className="wallet-card"
                    onClick={() => {
                      this.handleWalletCardClick(item.wallet_id);
                    }}
                    style={{ backgroundColor: `${item.background_color}` }}
                  >
                    <p className="name">{item.wallet_name}</p>
                    <div>
                      <p className="balance">balance</p>
                      <p className="amount">
                        ₹{currency.format(item.current_balance)}
                      </p>
                    </div>
                  </div>
                );
              })}
              {/* <div
            className="wallet-card"
            onClick={() => {
              this.handleWalletCardClick("new");
            }}
            style={{ backgroundColor: `#1c1c20` }}
          >
            <p className="name">add new merchant</p>
            <div>
              <p
                className="amount"
                style={{
                  color: "#d96f73",
                  fontSize: "3.5rem",
                  marginTop: "-10px",
                }}
              >
                +
              </p>
            </div>
          </div> */}
            </div>
            <Card className="recent-txns animated fadeInUp delay-1-5s">
              <p className="title">recent</p>
              {homeData.recent_txns.map((item, index) => {
                return (
                  <div
                    className="txns d-flex justify-between"
                    onClick={() => {
                      // this.handleTxnClick(item.txnId);
                    }}
                  >
                    <div className="timestamp txns-card">
                      <p className="date">
                        {moment(item.txn_date).format("DD")}
                      </p>
                      <p className="month">
                        {moment(item.txn_date).format("MMM")}
                      </p>
                      <p className="time">
                        {this.returnTime(moment(item.txn_date).format("hh:mm"))}
                      </p>
                    </div>
                    <div className="details txns-card">
                      <p className="value">
                        {item.txn_type === "LOAD" ? "+" : "-"} ₹
                        {currency.format(item.txn_amount)}
                      </p>
                      <p
                        className="info"
                        style={
                          item.txn_type === "LOAD"
                            ? { color: "#3a955d" }
                            : { color: "#e08f5f" }
                        }
                      >
                        {item.txn_info}
                      </p>
                      {item.txn_cashback_amount + item.bp_bonus_amount > 0 && (
                        <p className="cashback">
                          earned{" "}
                          <span>
                            ₹
                            {currency.format(
                              item.txn_cashback_amount + item.bp_bonus_amount
                            )}
                          </span>{" "}
                          cashback
                        </p>
                      )}
                      <p className="name">{item.txn_wallet_name}</p>
                    </div>
                  </div>
                );
              })}
            </Card>
          </>
        )}
        <DefaultModal
          visible={this.state.isSettingsVisible}
          className="settings_modal"
          animation="slideUp"
          onClose={() =>
            this.setState({
              isSettingsVisible: false
            })
          }
        >
          <div className="setings_action" style={{margin: '20px 0'}}>
            <p
              className="actionable"
              onClick={() => {
                // this.handleInvite();
              }}
            >
              <img src={require("../../assets/question.svg")} />
              Support
            </p>
            <hr />
            <p
              className="actionable"
              onClick={() => {
                window.localStorage.removeItem('access_token')
				        history.push('/login')
              }}
            >
              <img src={require("../../assets/logout.svg")} />
              Log Out
            </p>
          </div>
          {/* <button
            className="button logout"
            onClick={() => {
              props.logoutAction()
            }}
          >
            Log Out
          </button> */}
        </DefaultModal>
      </div>
    );
  }
}

const mapStateToProps = ({ home }) => ({
  homeData: home.data,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  fetchHomeFeed: (data) => dispatch(fetchHomeFeed(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
